import { Chip } from '@mui/material';
import { ReactComponent as PausedIcon } from '@src/assets/icons/layup/pause.svg';
import { ReactComponent as CheckedIcon } from '@src/assets/icons/layup/checked.svg';
import { ReactComponent as ClockIcon } from '@src/assets/icons//layup/clock.svg';
import { ReactComponent as LoadingIcon } from '@src/assets/icons//layup/loading.svg';
import { ReactComponent as CheckingIcon } from '@src/assets/icons//layup/search.svg';

import type { ComponentType } from 'react';
import { LayUpStatuses } from '@src/constants/LayupStatuses';

interface StatusConfig {
  Icon: ComponentType;
  label: string;
  borderColor: string;
  color: string;
}

const STATUS_CONFIG: Record<LayUpStatuses, StatusConfig> = {
  Missing: {
    Icon: PausedIcon,
    label: 'Paused - Missing items',
    borderColor: '#F14336',
    color: '#F14336',
  },
  LayUpPaused: {
    Icon: PausedIcon,
    label: 'Paused',
    borderColor: 'rgba(157, 165, 186, 1)',
    color: 'rgba(157, 165, 186, 1)',
  },
  Checked: {
    Icon: CheckedIcon,
    label: 'Checked',
    borderColor: '#00B890',
    color: '#00B890',
  },

  CheckPending: {
    Icon: ClockIcon,
    label: 'Requires check',
    borderColor: 'rgba(255, 171, 0, 1)',
    color: 'rgba(255, 171, 0, 1)',
  },

  LayUpInProgress: {
    Icon: LoadingIcon,
    label: 'In progress',
    borderColor: 'primary.main',
    color: 'primary.main',
  },

  Checking: {
    Icon: CheckingIcon,
    label: 'Checking',
    borderColor: '#4239CE',
    color: '#4239CE',
  },

  CheckedMissing: {
    Icon: CheckedIcon,
    label: 'Checked - Missing items',
    borderColor: 'rgba(241, 67, 54, 1)',
    color: 'rgba(241, 67, 54, 1)',
  },
};

interface Props {
  status: LayUpStatuses;
}

function LayupTextIcon({ status }: Props) {
  const { Icon, label, borderColor, color } = STATUS_CONFIG[status];

  return (
    <Chip
      size="small"
      variant="outlined"
      label={label}
      icon={<Icon />}
      sx={{
        borderColor,
        color,
        fontWeight: 500,

        '& .MuiChip-icon path': {
          fill: color,
        },
      }}
    />
  );
}

export default LayupTextIcon;
